<template lang="html">
  <content-block :controls="controls" :fresh="block.edit" @edit="editBlock()" @input="saveChanges()" @remove="deleteBlock()">
    <div v-if="edit">
      <div class="admin_files">
        <label class="admin_files__header">{{ $t('content_block_files_label') }}</label>
        <table class="admin_files__container table table-bordered table-striped">
        <thead>
          <tr>
            <th>{{ $t('id') }}</th>
            <th>{{ $t('url') }}</th>
            <th>{{ $t('label') }}</th>
            <th>{{ $t('controls') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(file, index) in block.data.files" :key="index" class="admin_files__item">
            <td>{{ index }}</td>
            <td><a :href="options.baseImagePath + '/' + file.file">{{ file.name }}</a></td>
            <td><input class="form-control" type="text" v-model="file.label"></td>
            <td>
              <button class="admin_files__button admin_files__button--remove btn btn-sm btn-danger"
                      @click.prevent="removeFile(file, index)">
                <fa icon="times" fixed-width />
              </button>
            </td>
          </tr>
        </tbody>
        </table>

        <label class="admin_files__header">{{ $t('file_to_upload') }}</label>
        <table class="table table-bordered table-striped admin_files__queue files_table">
          <thead>
            <tr>
              <th class="files_table__name_header">{{ $t('file_name') }}</th>
              <th class="files_table__size_header">{{ $t('file_size') }}</th>
              <th class="files_table__status_header">{{ $t('file_status') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(file, index) in files" class="files_table__row" :key="file.id">
              <td class="files_table__name">{{ file.name }}</td>
              <td class="files_table__size">{{ file.size }}</td>
              <td class="files_table__status">
                <span class="files_table__error" v-if="file.error">{{ file.error }}</span>
                <span class="files_table__success" v-else-if="file.success">success</span>
                <span class="files_table__active" v-else-if="file.active">active</span>
                <span class="files_table__else" v-else></span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="admin_files__controls">
          <file-upload
            style="margin-bottom: 0;"
            class="admin_files__button admin_files__button--select btn btn-sm btn-primary"
            name="file"
            :post-action="options.postFileUrl"
            :multiple="true"
            :size="1024 * 1024 * 10"
            v-model="files"
            @input-filter="inputFilter"
            @input-file="inputFile"
            ref="upload">
            <i class="fa fa-plus"></i>
            Select files
          </file-upload>
          <button type="button"
                  class="admin_files__button admin_files__button--upload btn btn-sm btn-success"
                  v-if="!$refs.upload || !$refs.upload.active"
                  @click.prevent="$refs.upload.active = true">
            <i class="fa fa-arrow-up" aria-hidden="true"></i>
            Start Upload
          </button>
          <button type="button"
                  class="admin_files__button admin_files__button--stop btn btn-sm btn-danger"
                  v-else
                  @click.prevent="$refs.upload.active = false">
            <i class="fa fa-stop" aria-hidden="true"></i>
            Stop Upload
          </button>
        </div>
      </div>
    </div>
    <div v-else class="content_block__files cb-files">
      <a class="cb-files__item" v-for="(file, index) in block.data.files" download :href="options.baseFilePath + '/' + file.file" :key="index">
        <i class="cb-files__icon" :class="'cb-files__icon--' + file.extension"></i>
        <div class="cb-files__label">{{ file.label }}</div>
        <i class="cb-files__icon cb-files__icon--cloud"></i>
      </a>
    </div>
  </content-block>
</template>

<script>
  import ContentBlock from './ContentBlock'
  import VueUploadComponent from 'vue-upload-component'
  import { Form } from 'vform'

  export default {
    components: {
      ContentBlock,
      FileUpload: VueUploadComponent,
    },
    name: "ContentBlockFiles",
    props: {
      block: {
        type: Object,
      },
      options: {
        type: Object,
        default: () => ({
          postFileUrl: '/upload/post'
        })
      },
      controls: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        edit: false,
        files: [],
      }
    },
    mounted () {
      if (this.controls) {
        this.edit = this.block.edit || false;
      }
    },
    methods: {
      editBlock () {
        this.edit = true;
      },
      deleteBlock () {
        this.$emit('remove')
      },
      saveChanges() {
        this.edit = false;
        this.$emit('input', this.block)
      },
      async removeFile (file, index) {
        let specialForm = new Form({
          file_name: file.file
        });

        await specialForm.delete(this.options.postFileUrl);
        this.block.data.files.splice(index, 1);
      },

      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Before adding a file
          // Filter system files or hide files

          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }

          // Filter php html js file
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }
      },

      inputFile(newFile, oldFile) {

        if (newFile && !oldFile) {
          // add
          console.log('add')
        }
        if (newFile && oldFile) {

          const re = /(?:\.([^.]+))?$/;

          // Uploaded successfully
          if (newFile.success !== oldFile.success) {
            this.block.data.files.push({
              file: newFile.response,
              name: newFile.file.name,
              label: newFile.file.name,
              type: newFile.file.type,
              size: newFile.file.size,
              extension: re.exec(newFile.file.name)[1]
            });
          }
        }

        if (!newFile && oldFile) {
          // remove
          console.log('remove', oldFile)
        }
      }
    }
  }
</script>
